import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-pdf-to-image',
    imports: [],
    templateUrl: './blog-pdf-to-image.component.html',
    styleUrl: './blog-pdf-to-image.component.css'
})
export class BlogPdfToImageComponent {

}
